// Personality Archetypes for Character Soul feature

export const PERSONALITY_ARCHETYPES = [
  { 
    id: 'lider', 
    name: 'LÍDER', 
    desc: 'Confiado, directo',
    icon: 'Trophy',
    traits: 'Postura erguida, pecho hacia adelante, gestos amplios y seguros, mirada directa y penetrante, mandíbula firme, movimientos decisivos y controlados, ocupa espacio con confianza'
  },
  { 
    id: 'pensador', 
    name: 'PENSADOR', 
    desc: 'Analítico, reflexivo',
    icon: 'Eye',
    traits: 'Movimientos pausados y deliberados, mirada reflexiva hacia arriba o al horizonte, gestos de mano al mentón, ceño ligeramente fruncido, postura contemplativa, parpadeos lentos'
  },
  { 
    id: 'energetico', 
    name: 'ENERGÉTICO', 
    desc: 'Extrovertido, expresivo',
    icon: 'Zap',
    traits: 'Movimientos rápidos y amplios, sonrisa amplia y frecuente, cejas muy expresivas, gesticula mucho con las manos, cambia de posición constantemente, ojos brillantes y abiertos'
  },
  { 
    id: 'calmado', 
    name: 'CALMADO', 
    desc: 'Introvertido, sereno',
    icon: 'MessageCircle',
    traits: 'Gestos sutiles y contenidos, movimientos suaves y fluidos, expresión serena, respiración visible y pausada, sonrisa sutil, mirada tranquila, postura relajada pero presente'
  },
  { 
    id: 'cool', 
    name: 'COOL', 
    desc: 'Relajado, casual',
    icon: 'PartyPopper',
    traits: 'Postura casual y desgarbada, movimientos fluidos sin prisa, media sonrisa o smirk, mirada confiada pero relajada, gestos mínimos pero con estilo, actitud despreocupada'
  },
  { 
    id: 'intenso', 
    name: 'INTENSO', 
    desc: 'Determinado, apasionado',
    icon: 'Megaphone',
    traits: 'Mirada fija e intensa, mandíbula apretada, movimientos con propósito y fuerza, gestos enfáticos, ceño concentrado, postura hacia adelante, energía contenida lista para explotar'
  },
  { 
    id: 'amigable', 
    name: 'AMIGABLE', 
    desc: 'Cálido, accesible',
    icon: 'MessageSquare',
    traits: 'Sonrisa genuina que llega a los ojos, postura abierta e invitante, gestos acogedores, inclinación hacia el interlocutor, expresiones faciales suaves, movimientos cálidos'
  },
  { 
    id: 'custom', 
    name: 'PERSONALIZADO', 
    desc: 'Describe la personalidad',
    icon: 'Hand',
    traits: ''
  },
];

export default PERSONALITY_ARCHETYPES;
